const component = () => import('./BootcampPage.vue');

export default [
  {
    path: '/v5/bootcamp',
    name: 'V5_bootcamp',
    component,
    // Earlier v5 links put the bootcamp in ?slug=
    beforeEnter: (to) => {
      const { slug, ...query } = to.query;
      return slug ? { path: `/v5/bootcamp/${encodeURIComponent(slug)}`, query } : true;
    },
  },
  { path: '/v5/bootcamp/:slug', name: 'V5_bootcamp_detail', component },
];
